import React from 'react';
import { useLanguage } from '../../hooks/useLanguage';

const TopUsersTable = ({ data, loading }) => {
    const { t } = useLanguage();
    if (loading) {
        return (
            <div className="card shadow-sm h-100">
                <div className="card-body">
                    <h5 className="card-title mb-4">{t('metrics.topUsers.title')}</h5>
                    <div className="placeholder-glow">
                        {[1,2,3,4,5].map(i => (
                            <div key={i} className="placeholder col-12 mb-2" style={{height: '40px'}}></div>
                        ))}
                    </div>
                </div>
            </div>
        );
    }

    if (!data || data.length === 0) {
        return (
            <div className="card shadow-sm h-100">
                <div className="card-body">
                    <h5 className="card-title mb-4">{t('metrics.topUsers.title')}</h5>
                    <div className="text-center text-muted py-5">
                        <i className="bi bi-person-badge" style={{fontSize: '3rem'}}></i>
                        <p className="mt-3">{t('metrics.noData')}</p>
                    </div>
                </div>
            </div>
        );
    }

    const getModuloBadgeClass = (modulo) => {
        return modulo === 'Policy Navigator' ? 'bg-primary' : 'bg-success';
    };

    const getRankingBadge = (ranking) => {
        if (ranking === 1) return '🥇';
        if (ranking === 2) return '🥈';
        if (ranking === 3) return '🥉';
        return ranking;
    };

    return (
        <div className="card shadow-sm h-100">
            <div className="card-body">
                <h5 className="card-title mb-4">
                    <i className="bi bi-trophy-fill me-2 text-warning"></i>
                    {t('metrics.topUsers.title')}
                </h5>
                
                <div className="table-responsive">
                    <table className="table table-hover align-middle">
                        <thead className="table-light">
                            <tr>
                                <th style={{width: '50px'}}>{t('metrics.topUsers.rank')}</th>
                                <th>{t('metrics.topUsers.user')}</th>
                                <th className="text-center">{t('metrics.topUsers.queries')}</th>
                                <th>{t('metrics.topUsers.favoriteModule')}</th>
                                <th>{t('metrics.topUsers.lastActivity')}</th>
                            </tr>
                        </thead>
                        <tbody>
                            {data.map((user) => (
                                <tr key={user.ranking}>
                                    <td className="text-center fw-bold">
                                        <span style={{fontSize: '1.2rem'}}>
                                            {getRankingBadge(user.ranking)}
                                        </span>
                                    </td>
                                    <td>
                                        <i className="bi bi-person-circle me-2 text-muted"></i>
                                        <span className="font-monospace small">{user.email}</span>
                                    </td>
                                    <td className="text-center">
                                        <span className="badge bg-secondary rounded-pill">
                                            {user.total_consultas}
                                        </span>
                                    </td>
                                    <td>
                                        <span className={`badge ${getModuloBadgeClass(user.modulo_favorito)}`}>
                                            {user.modulo_favorito}
                                        </span>
                                    </td>
                                    <td className="text-muted small">
                                        <i className="bi bi-clock me-1"></i>
                                        {user.ultima_actividad}
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    );
};

export default TopUsersTable;
